const ro = {
  common: {
    loading: "Încărcare...",
    close: "Aproape",
    submit: "Trimiteți",
    review: "Recenzie",
    help: "Ajutor",
    tour: "Tur",
    instructions: "Instrucţiuni",
    language: "Limbă",
    ok: "Bine",
    appLoaderText:
      "Încărcare... Vă rugăm să așteptați în timp ce pregătim mediul dvs. de evaluare."
  },
  assessment: {
    fetchError: "Eroare la preluarea {{featureName}}",
    somethingWentWrong: "Ceva a mers prost.",
    goBackToDashboard: "Reveniți la tabloul de bord",
    confirmSubmissionTitle: "Confirmați trimiterea",
    scheduleIdNotFound: "Id-ul programului nu a fost găsit",
    ongoingIdNotFound: "În curs de desfășurare Id-ul nu a fost găsit",
    errorFetchingOngoingData: "Eroare la preluarea datelor în curs",
    connectionRestoredLabel: "Conexiunea a fost restabilită.",
    connectionRestoredDescription:
      "Puteți continua să rulați cazuri de testare.",
    connectionLostLabel: "Am pierdut conexiunea la serverul de testare.",
    connectionLostDescription:
      "Nu veți putea rula sau valida cazuri de testare chiar acum.",
    featureNames: {
      assessment: "Evaluare",
      knowledgeCheck: "Verificarea cunoștințelor"
    },
    cardStatus: {
      na: "N/A",
      toBeLaunched: "Urmează să fie lansat",
      expired: "Expirat",
      expiringSoon: "Expiră curând",
      ongoing: "În desfășurare"
    },
    cardState: {
      draft: "Ciornă",
      published: "Publicat",
      cancelled: "Anulat",
      inreview: "În revizuire",
      readytopublish: "Gata de publicare",
      sentback: "Retrimis"
    },
    dashboard: {
      videoProctoring: "Video Proctoring",
      submitFeature: "Trimiteți {{featureName}}",
      noSectionsFound: "Nu au fost găsite secțiuni",
      expandAllSections: "Extindeți toate secțiunile",
      closeAllSections: "Închideți toate secțiunile",
      continueShapingAssessments: "Continuați să vă modelați evaluările",
      viewAll: "Vedeți tot",
      legend: {
        notStarted: "Nu a început",
        inProgress: "În curs",
        completed: "Terminat"
      }
    },
    confirmModal: {
      description:
        "Odată trimis, nu veți mai putea face nicio modificare {{featureName}}. Vă rugăm să revizuiți răspunsurile înainte de a confirma. Doriți să continuați cu trimiterea?",
      lowWordCountWarning:
        "Răspunsul dvs. la întrebare, {{questionTitle}} are mai puțin de 40 de cuvinte. Dacă trimiteți evaluarea acum, acest răspuns nu va fi salvat.",
      videoNotSubmittedWarning:
        "Videoclipul dvs. înregistrat pentru întrebarea {{questionTitle}} nu este trimis. Trimiterea evaluării acum va elimina acest răspuns.",
      unansweredQuestions: "Aveți {{count}} întrebări fără răspuns",
      andFlaggedQuestions: "și {{count}} întrebări semnalate",
      failedToFinish: "Nu s-a finalizat {{featureName}}"
    },
    feedback: {
      submittedTitle: "{{featureName}} dvs. a fost trimisă cu succes!",
      submittedDescription:
        "Răspunsurile dumneavoastră au fost trimise. Apreciem timpul și efortul pe care l-ați depus pentru a finaliza această {{featureName}}!",
      resultInProgress:
        "Rezultatul este calculat și poate dura până la un minut. Va rugam asteptati...",
      resultReady:
        "Rezultatul este gata! Faceți clic pe butonul Afișare rezultat pentru a-l vizualiza.",
      resultDelayed:
        "Calculul rezultatului durează mai mult decât de obicei. Vă rugăm să contactați administratorul pentru rezultatul dvs.",
      showResult: "Afișează rezultatul",
      redirectingToResult:
        "Redirecționare către pagina de rezultate în {{seconds}} secunde dacă nu faceți clic pe butonul Afișare rezultat",
      shareFeedbackTitle: "Împărtășește-ți feedbackul",
      shareFeedbackDescription:
        "Perspectivele tale deschid calea spre creștere. Haideți să creștem nivelul împreună!",
      errorSubmittingFeedback: "Eroare la trimiterea feedback-ului",
      feedbackSubmittedTitle: "Gata, feedback-ul este trimis!",
      feedbackSubmittedDescription:
        "Feedbackul dvs. a fost trimis. Vă mulțumim că ne ajutați să îmbunătățim experiența {{featureName}}!",
      feedbackAlreadySubmittedTitle:
        "Tot gata, feedback-ul a fost deja trimis!",
      feedbackAlreadySubmittedDescription:
        "Se pare că ați trimis deja feedbackul. Vă mulțumim că ne ajutați să îmbunătățim experiența {{featureName}}!"
    },
    page: {
      errorFetchingPreAssessmentData:
        "Eroare la preluarea datelor de preevaluare",
      connectionRestoredLabel: "Conexiunea a fost restabilită.",
      connectionRestoredDescription: "Se sincronizează ultimele modificări...",
      offlineLabel: "Se pare că ești offline.",
      offlineDescription:
        "Modificările nu se vor sincroniza până când vă reconectați"
    },
    question: {
      questions: "Întrebări",
      closeQuestionsPanel: "Închide panoul de întrebări",
      collapse: "Colaps",
      sectionSummary: "Rezumatul secțiunii",
      sections: "Secțiuni",
      toggleQuestionsPanel: "Comutați panoul de întrebări",
      switchModal: {
        switchQuestionButton: "Întrebare de comutare",
        leaveHeading: "Ești sigur că vrei să pleci?",
        discardMessage:
          "Aveți modificări nesalvate. Dacă modificați întrebarea, răspunsul dvs. va fi șters definitiv.",
        saveChangesButton: "Salvați modificările",
        saveHeading: "Doriți să salvați modificările?",
        saveBeforeSwitchMessage:
          "Aveți modificări nesalvate. Doriți să le salvați înainte de a schimba întrebarea?"
      }
    },
    faq: {
      q1: {
        question: "Ce ar trebui să fac înainte de a începe {{featureName}}?",
        firstSentence: "Asigurați-vă că ați completat următoarele:",
        list: {
          item1: "O conexiune la internet stabilă",
          item2:
            "O cameră web și un microfon care funcționează (dacă supravegherea video este activată)",
          item3: "Un mediu liniștit, fără distracție",
          item4:
            "Dacă supravegherea video este activată, vi se va solicita să finalizați o verificare a sistemului.",
          item5: "Citiți și sunteți de acord cu Termenii și condițiile"
        }
      },
      q2: {
        question:
          "Pot naviga între întrebări sau secțiuni în timpul {{featureName}}?",
        firstSentence: "Navigarea depinde de setări.",
        list: {
          item1:
            "Dacă navigarea în secțiuni este activată, vă puteți deplasa între secțiuni.",
          item2:
            "Dacă este dezactivată, va trebui să finalizați o secțiune înainte de a trece la următoarea."
        },
        lastSentence:
          "Instrucțiunile vor fi disponibile în orice moment în timpul {{featureName}}."
      },
      q3: {
        question: "Voi fi monitorizat în timpul testului?",
        list: {
          item1:
            "Dacă această {{featureName}} are activată supravegherea video, vor fi folosite camera și microfonul.",
          item2:
            "Orice activitate neobișnuită poate fi semnalată pentru examinare."
        }
      },
      q4: {
        question:
          "Ce se întâmplă dacă pierd conexiunea la internet sau închid browserul accidental?",
        firstSentence: "Progresul dvs. este salvat automat.",
        lastSentence:
          "Dacă are loc deconectarea, vă puteți reconecta la {{featureName}} folosind același link."
      },
      q5: {
        question: "Voi putea vedea rezultatele sau feedback-ul meu după test?",
        firstSentence:
          "Rezultatele și feedback-ul sunt configurate de organizatorul {{featureName}}.",
        list: {
          item1:
            "Dacă este activată, veți vedea scorul și rezumatul feedbackului după trimitere.",
          item2:
            "Dacă nu, rezultatele dvs. vor fi partajate prin e-mailul înregistrat."
        }
      }
    },
    labels: {
      totalDuration: "Durata totală",
      numberOfQuestions: "Nr. de întrebări",
      numberOfSections: "Nr. de secțiuni",
      guidelines: "Orientări",
      platformHelp: "Ajutor platformă",
      faq: "FAQ",
      frequentlyAskedQuestions: "Întrebări frecvente",
      showFeatureInstructions: "Afișați instrucțiunile {{featureName}}",
      minutes: "minute",
      welcome: "Bun venit",
      welcomeBack: "Bine ai revenit",
      userFallback: "Utilizator",
      defaultGuidelines:
        "Înainte de a începe {{featureName}}, asigurați-vă că vă aflați într-un spațiu liniștit, fără distracție, cu o conexiune la internet stabilă. Țineți camera pornită pe tot parcursul testului și gestionați-vă timpul cu înțelepciune, deoarece există o limită de timp. Dacă întâmpinați probleme tehnice, contactați imediat asistența. După ce ați terminat, examinați răspunsurile înainte de a trimite. Noroc!"
    },
    zoom: {
      textSize: "Dimensiunea textului:",
      decreaseTextSize: "Reduceți dimensiunea textului (A-)",
      resetTextSize: "Resetați dimensiunea textului (A)",
      increaseTextSize: "Măriți dimensiunea textului (A+)",
      decreaseInterfaceSize: "Reduceți dimensiunea interfeței",
      resetInterfaceSize: "Resetați dimensiunea interfeței",
      increaseInterfaceSize: "Măriți dimensiunea interfeței"
    },
    wrapper: {
      warningTitle: "Avertizare!",
      stayOnPageMessage:
        "Vă rugăm să rămâneți pe această pagină până când completați {{featureName}}.",
      iUnderstand: "Am înțeles",
      submitTheFeature: "Trimiteți {{featureName}}",
      videoProctoringInterrupted: "Video Proctoring întreruptă",
      continuationBlocked:
        "Continuarea evaluării este blocată până la restabilirea supravegherii video securizate.",
      retryProctoring: "Reîncercați Proctoring"
    },
    progress: {
      proceed: "Continuă",
      resumeFeature: "Reluați {{featureName}}",
      timeRemainingMessage:
        "rămânând în {{featureName}}. Faceți clic mai jos pentru a relua de unde ați rămas.",
      continueOnThisDevice: "Continuați pe acest dispozitiv?",
      switchToThisTab: "Comutați la această filă?",
      continueYourAssessmentHere: "Continuați evaluarea aici?",
      switchHere: "Comutați aici",
      attemptsUnlimited:
        "Aveți la dispoziție încercări nelimitate pentru această evaluare.",
      attemptsSingle:
        "Aveți <strong>1</strong> încercare disponibilă pentru această evaluare.",
      attemptsMultiple:
        "Aveți <strong>{{remainingAttempts}}</strong> din <strong>{{maxAttempts}}</strong> încercări disponibile pentru această evaluare.",
      coolOffAfterAttempt:
        "După fiecare încercare, va trebui să așteptați <strong>{{coolOffTime}}</strong> înainte de a începe următoarea încercare."
    },
    loginWindow: {
      expiredTitle: "Timpul de conectare a expirat",
      expiredMessage:
        "Fereastra de conectare pentru această {{featureName}} este acum închisă. Ai ratat timpul permis pentru a accesa testul."
    },
    coding: {
      saving: "Economisire",
      offlineTitle: "Se pare că ești offline",
      offlineDescription:
        "Modificările nu se vor sincroniza până când vă reconectați",
      connectionRestored: "Conexiunea a fost restabilită",
      syncingLatest: "Se sincronizează ultimele modificări...",
      autoSaveEnabled: "Salvare automată activată",
      runOnlyChecksDescription:
        "verifică doar codul tău folosind cazuri de test.",
      submitEvaluationDescription:
        "codul tău pentru a fi evaluat și pentru a primi punctaj.",
      reset: "Resetați",
      run: "Execută",
      runTests: "Teste de rulare",
      submit: "Trimiteți",
      submitting: "Trimiterea",
      resetCode: "Resetați codul",
      resetCodeMessage:
        "Sigur vrei să resetați? Acest lucru va elimina tot codul actual și va restabili codul de pornire",
      testCases: "Cazuri de testare",
      testCase: "Caz de testare {{index}}",
      testCasePassed: "Caz de testare a trecut",
      testCaseFailed: "Cazul de testare a eșuat",
      runtimeError: "Eroare de rulare",
      timeLimitExceeded: "Limita de timp a fost depășită",
      timeLimitExceededTitle: "Limita de timp a fost depășită",
      timeLimitExceededDescription:
        "Codul dvs. nu a fost executat în limitele de timp. Vă rugăm să vă optimizați codul.",
      input: "Intrare",
      expectedOutput: "Rezultat așteptat",
      yourOutput: "Ieșirea dvs",
      hiddenTestCase: "Caz de testare ascuns",
      hiddenTestCaseDescription:
        "Cazurile de testare ascunse sunt folosite pentru a evalua dacă codul dumneavoastră poate gestiona diferite scenarii, inclusiv cazuri de colț",
      explanation: "Explicaţie",
      hints: "Sugestii"
    },
    subjective: {
      minWordsRequired:
        "Sunt necesare minimum 40 de cuvinte pentru a trimite răspunsul.",
      enterYourAnswer: "Introduceți răspunsul dvs",
      submitResponse: "Trimiteți răspunsul",
      submittingResponse: "Se trimite răspunsul...",
      resetAnswer: "Resetează răspunsul",
      resetAnswerMessage:
        "Sigur vrei să resetați? Răspunsul dvs. actual va fi eliminat definitiv.",
      retake: "Relua",
      showHint: "Afișați indiciu",
      recording: "ÎNREGISTRARE"
    },
    systemCheck: {
      calibrate: "Calibra",
      calibrating: "Se calibrează...",
      accessDenied: "Acces interzis",
      cameraPermissionDenied:
        "Permisiune refuzată pentru cameră. Vă rugăm să activați accesul la cameră în setările browserului pentru a continua.",
      errorFetchingDevices: "Eroare la preluarea dispozitivelor",
      failedToStartAssessment: "Nu a putut începe evaluarea",
      unableToStartSecureProctoring:
        "Nu se poate începe supravegherea securizată acum. Vă rugăm să reîncercați.",
      unnamedCamera: "Cameră fără nume",
      facingCalibrationIssues: "Întâmpinați probleme cu calibrarea video?",
      lookAtCenter:
        "Vă rugăm să priviți în centrul ecranului și să rămâneți nemișcați.",
      unableToCalibrateTitle:
        "Nu vă puteți calibra camera pentru supraveghere video?",
      statusMessages: {
        readyForCalibration:
          "Asigurați-vă că fața este clar vizibilă și centrată pe ecran. Când este gata, faceți clic pe „Calibrați” pentru a începe.",
        calibratingInProgress:
          "Calibrare în curs. Continuă să te uiți la ecran.",
        calibratingTimedOut:
          "Calibrarea camerei a expirat. Vă rugăm să reîmprospătați browserul pentru a continua.",
        preparingCameraPreview:
          "Se pregătește fluxul camerei și urmărirea feței pentru calibrare.",
        retryRequired:
          "Configurarea Proctoring necesită acțiunea dvs. înainte de a continua.",
        proctoringUnavailable:
          "Proctoring este momentan indisponibil și evaluarea nu poate începe în siguranță.",
        calibrationCompleted:
          "Calibrare reușită! Sunteți gata să începeți evaluarea.",
        timeoutHelp:
          "Dacă încă vedeți acest mesaj, verificați dacă există alte file/aplicații folosind camera sau un obturator extern."
      },
      failureReasons: {
        cameraPermissionDenied:
          "Permisiunea camerei este blocată. Permiteți accesul și încercați din nou.",
        cameraUnavailable:
          "Camera foto nu este disponibilă. Verificați selecția dispozitivului și reîncercați.",
        facemeshInitFailed:
          "Configurarea urmăririi feței nu a reușit. Reîncercați să continuați.",
        cocoLoadFailed:
          "Motorul de supraveghere nu este disponibil. Actualizați și încercați din nou.",
        streamLostReacquireFailed:
          "Recuperarea fluxului camerei nu a reușit. Reîncercați supravegherea.",
        calibrationInsufficientData:
          "Probele de calibrare au fost insuficiente. Reîncercați calibrarea.",
        detectionCadenceUnavailable:
          "Configurarea cronometrarii nu este gata. Reîncercați în scurt timp."
      },
      calibrationInfo: {
        heading: "Pentru a calibra cu succes videoclipul, urmați acești pași:",
        followUpHeading:
          "Dacă încă vă confruntați cu problema, urmați acești pași:",
        initialSteps: {
          step1: {
            title: "Asigurați o iluminare bună",
            description:
              "Stați într-o zonă bine luminată, cu fața vizibilă. Evitați lumina puternică sau ferestrele din spatele dvs."
          },
          step2: {
            title: "Înfruntați direct camera",
            description:
              "Poziționați fața în centrul cadrului și priviți direct în cameră în timpul calibrării."
          },
          step3: {
            title: "Evitați fundalurile întunecate sau neclare",
            description:
              "Asigurați-vă că fundalul este clar și nu prea întunecat."
          },
          step4: {
            title: "Verificați permisiunile camerei",
            description:
              "Permiteți browserului să acceseze camera web când vi se solicită."
          },
          step5: {
            title: "Stai nemișcat și uită-te la ecran",
            description:
              "Țineți-vă capul neclintit în timpul calibrării pentru a ajuta sistemul să vă detecteze corect fața."
          }
        },
        laterSteps: {
          step1: "Încercați să reîmprospătați pagina și să recalibrați camera.",
          step2:
            "Închideți alte aplicații folosind camera web (cum ar fi Zoom sau Teams).",
          step3:
            "Dacă problema continuă, contactați {{contactEmail}} cu o captură de ecran a erorii."
        }
      }
    },
    stepper: {
      termsAndConditions: "Termeni și condiții",
      agreeTerms: "Am citit și sunt de acord cu termenii și condițiile.",
      previousStep: "Pasul precedent",
      nextStep: "Următorul pas",
      startAssessment: "Începeți evaluarea",
      resumeAssessment: "Reluați evaluarea",
      mediaCheck: "Verificare media",
      systemCheck: "Verificare sistem",
      audioCheck: {
        intro:
          "Puteți înregistra aici un videoclip scurt pentru a verifica dacă camera și microfonul funcționează conform așteptărilor.",
        mediaPermissionDenied:
          "Accesul la cameră sau microfon a fost refuzat. Vă rugăm să activați permisiunile în setările browserului.",
        startRecording: "Începe înregistrarea",
        stopRecording: "Oprește înregistrarea",
        unnamedMicrophone: "Microfon fără nume"
      },
      stepLabel: "PASUL {{step}}",
      personalDetails: "Detalii personale",
      emailId: "ID de e-mail",
      firstName: "Prenume",
      lastName: "Nume",
      defaultTncStatement:
        "Prin participarea la această evaluare, confirmați că îndepliniți cerințele de eligibilitate specificate de companie și sunteți de acord să finalizați testul în mod independent, fără asistență externă. Evaluarea este supusă supravegherii video și trebuie să aveți camera pornită pe tot parcursul sesiunii, într-un mediu fără distracție. Tot conținutul și materialele furnizate în timpul evaluării sunt confidențiale și nu trebuie partajate, reproduse sau distribuite. Sunteți de acord să respectați termenul stabilit pentru evaluare; nedepunerea înainte de termenul limită poate duce la descalificare. Compania nu este responsabilă pentru probleme tehnice legate de conexiunea dvs. la internet, software sau hardware. Datele personale colectate în timpul evaluării vor fi prelucrate numai în scopuri de evaluare și recrutare, în conformitate cu politica de confidențialitate a companiei. Orice încercare de a înșela, de a plagia sau de a se implica în alt mod într-un comportament neetic va duce la descalificarea imediată. Trimițând răspunsurile dvs., confirmați că acestea sunt finale și nu se pot face revizuiri după trimitere. Compania își rezervă dreptul de a modifica sau actualiza acești termeni în orice moment, iar participanții vor fi informați cu privire la orice modificări semnificative.",
      okay: "Bine"
    },
    access: {
      cancelledTitle: "„{{title}}” a fost anulat",
      cancelledDescription:
        "Această evaluare nu mai este activă și nu poate fi accesată. Vă rugăm să examinați tabloul de bord pentru alte evaluări atribuite sau viitoare.",
      goToHome: "Du-te la Acasă",
      refreshPage: "Actualizează pagina"
    },
    errorPage: {
      goBack: "Înapoi",
      raiseRequest: "Trimite solicitare",
      retryLogin: "Reîncearcă autentificarea",
      contactUs: "Contactați-ne",
      goBackToEvent: "Înapoi la eveniment",
      launchCourse: "Lansează cursul",
      created: "Creat",
      starts: "Începe",
      ends: "Se termină",
      untitled: "Fără titlu"
    },
    sidebar: {
      home: "Acasă",
      quickAccess: "Acces rapid",
      questionPaperAuthoring: "Creare chestionar",
      assessmentLibrary: "Biblioteca de evaluări",
      scheduleInterview: "Programează interviul",
      generateQuestions: "Generează întrebări",
      roleManagement: "Gestionarea rolurilor",
      logout: "Deconectare",
      noAccess: "Fără acces",
      noAccessWithLabel: "{{label}} (Fără acces)",
      noAccessToLink: "Nu aveți acces la acest link",
      expandSidebar: "Extinde bara laterală",
      collapseSidebar: "Restrânge bara laterală",
      expand: "Extinde",
      collapse: "Restrânge",
      myPreferences: "Preferințele mele"
    },
    timesUp: {
      title: "Timp de evaluare finalizat",
      autoSubmittedMessage:
        "Cronometrul a expirat. Răspunsurile dumneavoastră au fost salvate și {{featureName}} a fost trimisă automat."
    },
    resultCard: {
      title: "{{featureName}} Rezultate",
      score: "Scor",
      passPercentage: "Procentaj de promovare",
      marksAway:
        "Sunteți la {{count}} semne distanță de certificare. Concentrați-vă pe zonele recomandate și încercați din nou.",
      certificationEarned:
        "Ați depășit cerințele de certificare și ați obținut certificarea",
      congratulationsOnEarning:
        "Felicitări pentru obținerea certificării {{featureName}}",
      almostThereTitle: "Ești mai aproape decât crezi de a obține certificarea",
      certificatePassedDescription:
        "Ați demonstrat cunoștințele și abilitățile necesare pentru a obține această certificare. Luați un moment pentru a sărbători această realizare și împărtășiți-o cu rețeaua dvs",
      certificateFailDescription:
        "Această încercare a evidențiat oportunități de a vă consolida abilitățile. Examinați zonele recomandate și reveniți cu încredere",
      congratsImageAlt: "Felicitari imagine",
      almostThereImageAlt: "Aproape acolo Imagine"
    },
    sectionCard: {
      section: "Secțiune",
      startSection: "Începeți secțiunea",
      continueSection: "Continuați secțiunea",
      completed: "Terminat",
      viewSection: "Vizualizare secțiune",
      totalQuestions: "Total întrebări:",
      sectionNotFound: "Secțiunea nu a fost găsită.",
      total: "Total",
      flagged: "Semnalat"
    },
    sectionSummary: {
      totalQuestions: "Total întrebări",
      completedQuestions: "Întrebări completate",
      flaggedQuestions: "Întrebări semnalizate",
      unattemptedQuestions: "Întrebări neîncercate",
      codingQuestions: "Întrebări de codificare:",
      objectiveQuestions: "Întrebări obiective:",
      goToSections: "Accesați secțiunile",
      lowWordCountWarning:
        "Răspunsul dvs. la întrebare, {{questionTitle}} are mai puțin de 40 de cuvinte. Dacă reveniți la lista de secțiuni, acest răspuns va fi eliminat.",
      videoNotSubmittedWarning:
        "Videoclipul dvs. înregistrat pentru întrebarea {{questionTitle}} nu este trimis. Dacă reveniți la lista de secțiuni, acest răspuns va fi eliminat."
    },
    objective: {
      questionCounter: "Întrebare",
      marks: "Marcaje:",
      explanation: "Explicaţie",
      hints: "Sugestii",
      reset: "Resetați",
      flag: "Pavilion",
      unflag: "Anulați semnalizarea",
      previous: "Anterior",
      saveAndNext: "Salvați și Următorul",
      saveAndViewSummary: "Salvați și vizualizați rezumatul secțiunii",
      next: "Următorul",
      viewSectionSummary: "Vedeți rezumatul secțiunii",
      hideExplanation: "Ascunde explicația",
      showExplanation: "Arată explicația",
      hintWaitTooltip: "Trebuie să așteptați înainte de a vedea un alt indiciu",
      noHintsPendingTooltip: "Nu există indicii în așteptare",
      selectOptionForExplanation:
        "Selectați opțiunea pentru a vedea explicația opțiunii selectate"
    },
    tour: {
      shared: {
        timer:
          "Acest cronometru afișează timpul rămas pentru evaluarea dvs. Vă rugăm să îl monitorizați îndeaproape pentru a vă asigura că finalizați toate secțiunile în timpul alocat.",
        submit:
          "După ce ați finalizat toate secțiunile evaluării, vă puteți trimite munca făcând clic pe butonul „Trimite evaluarea”. Această acțiune finalizează răspunsurile dvs. și nu veți mai putea face modificări odată ce sunt trimise. Asigurați-vă că ați revizuit toate răspunsurile înainte de a continua cu trimiterea."
      },
      dashboard: {
        legend:
          "Legenda stării secțiunii vă ajută să înțelegeți progresul dvs. pe parcursul evaluării. Folosește indicatori clari pentru a arăta dacă o secțiune nu a fost începută, este în curs de desfășurare sau a fost finalizată. Acest lucru vă permite să evaluați rapid ce părți necesită încă atenția dvs. și să vă gestionați timpul în mod eficient.",
        sectionCard:
          "Fișa secțiunii oferă o prezentare detaliată a fiecărei secțiuni de evaluare. Afișează titlul secțiunii, starea sa actuală și informații cheie despre întrebările din secțiune. Aceasta include numărul total de întrebări, numărul de întrebări marcate și numărul de întrebări care au fost completate. Cardul secțiunii vă ajută să vă monitorizați progresul și să identificați zonele care ar putea necesita mai multă atenție."
      },
      coding: {
        titles:
          "În partea de sus a paginii, veți găsi o afișare clară a titlului evaluării și a titlului secțiunii. Acest lucru vă ajută să urmăriți sarcina curentă și vă asigură că sunteți la curent cu secțiunea specifică la care lucrați. Consultați aceste titluri pentru a rămâne orientat pe măsură ce navigați prin întrebări.",
        sectionsButton:
          "Acest buton vă permite să navigați cu ușurință înapoi la tabloul de bord al secțiunilor. Folosiți-l pentru a reveni la prezentarea generală principală a evaluării dvs., unde puteți vizualiza și gestiona progresul tuturor secțiunilor. Acesta oferă o modalitate rapidă de a vă reevalua progresul general fără a pierde nimic din munca dvs. curentă.",
        sidebar:
          "Bara laterală oferă o prezentare generală a tuturor întrebărilor din secțiunea curentă pe care o încercați. Vă permite să navigați rapid între întrebări prin simpla selectare a blocului relevant. Fiecare bloc de întrebări este codificat cu culori în funcție de starea sa, ceea ce face ușoară urmărirea progresului și trecerea la întrebări specifice, după cum este necesar.",
        questionCard:
          "Acest card conține întrebarea la care lucrați în prezent, afișând solicitarea completă și orice instrucțiuni relevante sau cerințe de introducere. Este conceput pentru a vă oferi o imagine clară asupra sarcinii în cauză, cu toate informațiile necesare pentru a continua. Veți găsi, de asemenea, un buton pentru a semnala întrebarea pentru o revizuire ulterioară, permițându-vă să o revedeți cu ușurință dacă este necesar. În plus, există butoane de navigare care vă permit să treceți la întrebarea următoare sau anterioară fără a vă întoarce la bara laterală, asigurând o progresie lină și eficientă prin evaluare.",
        editor:
          "Editorul de cod este locul în care veți scrie și modifica soluțiile. Puteți comuta între diferite limbaje de programare pentru a se potrivi cerințelor fiecărei întrebări. În plus, aveți opțiunea de a ajusta tema editorului pentru o experiență de codare mai confortabilă. Dacă preferați mai mult spațiu pe ecran, editorul poate fi extins la lățime completă, oferindu-vă o zonă mai mare pentru a lucra. Aceste caracteristici sunt concepute pentru a oferi un mediu flexibil și ușor de utilizat pe măsură ce vă finalizați sarcinile de codare."
      }
    },
    toast: {
      proctoringViolationDetected: "S-a detectat o încălcare a supravegherii",
      messages: {
        forbiddenObjectDetected: "Obiect interzis detectat",
        noFaceDetected: "Nu a fost detectată nicio față",
        multipleFacesDetected: "Mai multe fețe detectate",
        lookingAwayFromScreen: "Privind departe de ecran",
        notLookingAtScreen: "Nu se uită la ecran",
        faceNotOrientedCorrectly: "Fața nu este orientată corect",
        eyesNotFullyOpen: "Ochii nu sunt complet deschiși",
        copyNotAllowed: "Copierea nu este permisă",
        cutRestricted: "Tăierea este restricționată în modul de supraveghere",
        pasteNotAllowed: "Lipirea nu este permisă",
        contextMenuNotAllowed: "Deschiderea meniului contextual nu este permisă"
      }
    },
    whatsNext: {
      heading: "Ce urmează?",
      attemptsRemaining: "încercări rămase",
      passed: {
        shareLinkedInTitle: "Distribuie pe LinkedIn",
        shareLinkedInSubtitle:
          "Sărbătorește-ți realizarea cu rețeaua ta profesională.",
        viewCertificateTitle: "Vedeți certificatul",
        viewCertificateSubtitle:
          "Descărcați sau accesați certificarea oricând.",
        shareGloTitle: "Distribuie experiența",
        shareGloSubtitle:
          "Inspirați colegii publicând realizările dvs. în interior."
      },
      failed: {
        reviewLearningResourcesTitle: "Consultați resursele de învățare",
        reviewLearningResourcesSubtitle:
          "Întăriți abilitățile care necesită atenție.",
        retakeAssessmentTitle: "Refaceți evaluarea",
        retakeAssessmentSubtitle:
          "Demonstrați progresul dvs. și înțelegerea actualizată."
      },
      modal: {
        title: "Distribuie realizare",
        linkedInPostLabel: "Distribuie pe LinkedIn ca Postare",
        linkedInProfileLabel: "Adăugați ca certificare la profilul LinkedIn",
        gloLabel: "Distribuie pe Glo",
        comingSoon: "În curând",
        infoMessage:
          "Trebuie să fii autentificat pe platformă pentru a partaja."
      }
    },
    time: {
      hour_one: "{{count}} oră",
      hour_other: "{{count}} ore",
      minute_one: "{{count}} minut",
      minute_other: "{{count}} minute",
      hourShort: "h",
      minuteShort: "min",
      secondShort: "s"
    },
    accessScreens: {
      attemptResultProcessing: {
        alt: "{{featureName}} rezultatele sunt procesate",
        title: "Rezultatele dvs. sunt procesate",
        description:
          "Încă vă examinăm {{featureName}}. Vă rugăm să reveniți în curând!"
      },
      coolOffPeriod: {
        alt: "Perioada de răcire",
        title: "Următoarea încercare disponibilă în curând",
        completedAttempt: "Ați finalizat deja o încercare pentru aceasta",
        nextAttemptIntro: ". Următoarea încercare va fi disponibilă în"
      },
      maxAttemptExceeded: {
        alt: "Maximul de încercări a fost atins",
        title: "Maximul de încercări atins",
        description:
          "Ați folosit toate încercările disponibile pentru această {{featureName}}. Nu mai pot fi făcute încercări."
      },
      scheduleNotStarted: {
        alt: "Programul nu a început",
        title: "{{featureName}} Nu a început încă",
        scheduledPrefix: "The",
        scheduledOn: "este programat să înceapă",
        checkBack:
          "Vă rugăm să verificați din nou în {{time}} sau să reîmprospătați odată ce ora începe."
      },
      scheduleTimeCompleted: {
        alt: "Ora programată s-a încheiat",
        title: "{{featureName}} Fereastra închisă",
        description:
          "Ora programată pentru această {{featureName}} a trecut. Nu mai puteți începe sau trimite o încercare."
      }
    },
    attemptDetails: {
      allAttempts: "Toate încercările",
      headers: {
        attempt: "Încercare",
        attemptedOn: "A încercat",
        percentage: "Procent"
      },
      viewAllAttempts: "Vedeți toate încercările"
    },
    survey: {
      questions: {
        q1: "Pe o scară de la 1 la 5, cât de clare ați găsit întrebările {{featureName}}?",
        q2: "M-am simțit pregătit adecvat pentru subiectele discutate în {{featureName}}",
        q3: "Platforma folosită pentru {{featureName}} a fost ușor de utilizat și funcțională",
        q4: "Cred că răspunsurile mele au arătat în mod eficient abilitățile și cunoștințele mele"
      },
      stronglyDisagree: "Total dezacord",
      stronglyAgree: "Foarte de acord",
      submitFeedback: "Trimiteți feedback"
    },
    cameraPreview: {
      loadingAlt: "Se încarcă previzualizarea camerei",
      delayedMessage:
        "Calibrarea durează mai mult decât se aștepta din cauza unei rețele lente. Vă rugăm să așteptați sau încercați să reîmprospătați pagina."
    },
    proctoring: {
      engineLoadFailedStatus: "Motorul de proctoring nu s-a încărcat",
      runtimeErrors: {
        cameraPermissionDenied:
          "Accesul la cameră este blocat de setările de permisiuni ale browserului.",
        cameraUnavailable:
          "Camera foto nu este disponibilă sau este utilizată în prezent de altă aplicație.",
        unableToLoadModel:
          "Imposibil de încărcat modelul de detectare a obiectelor de supraveghere.",
        webglRecoveryFailed:
          "Recuperarea WebGL a eșuat în timpul restabilirii detectării obiectelor."
      },
      logs: {
        engineLoadFailed: "ProctoringEngine nu s-a încărcat:",
        videoPlayRejected: "Redare video() respinsă:",
        cameraTrackEnded:
          "Traseul camerei s-a încheiat - se încearcă re-achiziție",
        cameraReacquired: "Camera foto re-obținută la încercare {{attempt}}",
        cameraReacquireAttemptFailed:
          "Încercarea de re-achiziție a camerei {{attempt}} a eșuat:",
        cameraReacquireFailedAll:
          "Reachiziția camerei nu a reușit după toate încercările - camera de raportare deconectată la fiecare ciclu",
        uploadFailedQueued:
          "Încărcarea de supraveghere a eșuat după {{attempts}} încercări, în coadă pentru reîncercare:",
        uploadAttemptFailedRetrying:
          "Încercarea de încărcare a supravegherii {{attempt}} a eșuat, se reîncercă...",
        drainedQueuedViolation:
          "Încălcare în coadă epuizată: {{violationType}} ({{remaining}} rămas)",
        queueDrainFailed:
          "Evacuarea cozii a eșuat, va încerca din nou ciclul următor:",
        cocoLoadFailed: "Încărcarea COCO-SSD a eșuat:",
        faceProcessingError: "Eroare de procesare a feței:",
        errorProcessingFrame: "Eroare la procesarea cadrului:",
        faceMeshInitError: "Eroare de inițializare a rețelei faciale:"
      }
    }
  }
} as const;

export default ro;
